



















































































































































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { GrantData, GrantSummary, IGrantSummary } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Workspace, ApplicationSubmit } from "@/entities";
import Schedule from "./Summary/schedule.vue";
import PerformanceSummary from "./Summary/performance.summary.vue";
import OwnershipChange from "./OwnershipChange.vue";
import { Locales } from "@/i18n/locales";

const namespace: string = "grant";

@Component({
  components: {
    Schedule,
    PerformanceSummary,
    OwnershipChange,
    Dialog: () => import("@/components/common/Dialog/DialogComponent.vue"),
    AmendmentRequest: () => import("./../../Amendment/AmendmentRequest.vue"),
  },
})
export default class GrantSummaryComponent extends Vue {
  @State(namespace) grant!: GrantData;
  @State("application") application!: Workspace;
  @Action("getApplication", { namespace: "application" }) getApplication: any;
  @Action("resetAppState", { namespace: "application" }) resetAppState: any;
  @Action("setApplicationId", { namespace: "application" }) setApplication: any;
  @Action("saveAll", { namespace }) saveAll: any;
  @Action("updatePPO", { namespace }) updatePPO: any;
  @Action("changeOwnership", { namespace: "grant" }) changeOwnership: any;
  @Getter("rootTemplate", { namespace: "application" }) schema: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("appSubmit", { namespace: "application" }) appSubmit: ApplicationSubmit;
  @Getter("projectYrs", { namespace: "application" }) years: any;
  @Getter("reportingFrequency", { namespace: "application" }) reportingFreq: any;
  @Action("createAmendment", { namespace: "grantAmendment" }) createAmendment: any;
  @Action("showNotification", { namespace: "application" }) notify: any;
  @Prop() appId: any;
  actions = _app.actions;
  subjects = _app.subjects;
  permission = true;
  dialog = false;
  items = [];
  internalReview = {};
  readonlyPPO = 0;
  editedPPO = 0;
  summary: GrantSummary = new GrantSummary({} as IGrantSummary);
  granteeId = 0;
  grantees = [];

  amendmentRequestLoader = false;
  terminationLoader = false;
  suspensionLoader = false;
  resumeLoader = false;
  showAmendment = false;
  showSuspend = false;
  showTerminate = false;
  showResumeGrant = false;
  actionPopup = 0;
  amendmentActions = [
    { event: "save", text: "Request" },
    { event: "close", text: "Close" },
  ];
  amendmentRequest: any = {
    applicantId: 0,
    amendmentTypeId: [],
    reason: ""
  };
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
    this.$services.grant.ActiveUsersByUserType().then((resp: any) => {
      if (resp.Result == "OK") {
        this.items = resp.Record;
      }
    });

    /** Get the summary info */
    this.$services.grant
      .getGrantSummary(this.grant.selectedGrant.GrantId)
      .then((resp: any) => {
        if (resp) {
          this.summary = new GrantSummary(resp as IGrantSummary);
        }
      });

    this.getInternalReview();
    this.readonlyPPO = this.grant.selectedGrant.PrimaryProgramOfficerId;
    this.editedPPO = this.grant.selectedGrant.PrimaryProgramOfficerId;
    this.granteeId = this.grant.selectedGrant.ApplicantId;
  }

  get actionItems() {
    switch (this.grant.selectedGrant.WorkflowStatusCode) {
      // Terminated
      case 'TER':
        return [];
    
      // Suspended
      case 'SUS':
        return _app.grantActionItems.filter(x=> [3, 4].includes(x.value));

      default:
        return _app.grantActionItems.filter(x=> x.value != 4);
    }
  }

  updateOwner(data) {
    this.changeOwnership({
            id: data.id,
            userId: data.userId,
        }).then((resp) => {
          this.grant.selectedGrant.ApplicantId = data.userId;
        });
  }

  cancelPPO() {
    this.dialog = false;
    this.editedPPO = this.readonlyPPO;
  }

  savePPO() {
    this.updatePPO({
      id: this.grant.selectedGrant.GrantId,
      ppoid: this.editedPPO,
    }).then((resp) => {
      this.readonlyPPO = this.grant.selectedGrant.PrimaryProgramOfficerId;
      this.dialog = false;
    });
  }

  formatCurrency(val, currency) {
    return utils.formatCurrency(val, currency, this.defaultLocale);
  }

  showAgreement() {
    var grantId = this.grant.selectedGrant.GrantId.toString();
    this.$router.push({
      name: "grantAgreement",
      params: { grantId: grantId },
    });
  }

  showReadOnlyAgreement() {
    var grantId = this.grant.selectedGrant.GrantId.toString();
    this.$router.push({
      name: "grantAgreementReadOnly",
      params: { grantId: grantId },
    });
  }
  // formatDateTime(val) {
  //     return utils.formatDateTime(val).split('-')[0];
  // }

  download(proposalId) {    
    let self = this;
    const appId =
      typeof proposalId === "string" ? parseInt(proposalId) : proposalId;
    this.getApplication(appId).then((data: any) => {      
      if (data && data.projectTitle) {
        this.generatePdf();
      }
    });
  }

  generatePdf() {
     let applicationData;

switch (this.application.application.BudgetType) {
  case 'Tiger':
    applicationData = {
      ...this.application.data,
      amountOfMatchingFund: this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0
    };
    break;
  case 'CAG':
    applicationData = {
      ...this.application.data,
      fundingRequests: this.application.data.totalProjectBudgect || 0
    };
    break;
  default:
    applicationData = this.application.data;
    break;
}
    this.$services.pdf.generate({
      entity: "Application",
      schema: this.schema,
      data: applicationData,
      user: this._username,
      currency: this.application.application.BudgetCurrency,
      id: this.application.application.ApplicationId,
      code: this.application.application.Code,
      type: this.application.templates["IsRAGTemplate"] ? "RAG" : "TSG",
      "checklist": this.appSubmit.checklist,
      "years":this.years,
      "Quaters":this.reportingFreq,
      "logSchema": this.application.logSchema
    });
  }

  getInternalReview() {
    if (this.appid_computed !== NaN && this.appId !== undefined) {
      this.$services.reviewinternal
        .reviewSummary(this.appid_computed || this.appId, 'Application')
        .then((resp) => {
          this.internalReview = resp;
        });
    }
  }

  triggerAction(item) {
    this.actionPopup += 1;

    switch (item.value) {
      case 1:
        this.showAmendment = true;
        break;

        case 2:
        this.showSuspend = true;       
        break;

      case 3:
        this.showTerminate = true;
        break;

      case 4:
        this.showResumeGrant = true;
        break;
    }
  }

  get appid_computed() {
    return parseInt(this.$route.params.appId);
  }

  /** permissions for changing primary prog officer */
  get enableButton() {
    //@ts-ignore
    if (this.$can(this.actions.update, this.subjects.ppo)) {
      // show button for program admins and system admins
      return true;
    }
  }

  /** permissions for changing ownership */
  get enableButtonForSysAdmin() {
    //@ts-ignore
    if (this.$can(this.actions.update, this.subjects.ownershipChange)) {
      // show button for system admins
      return true;
    }
  }

  get buttonVisibility() {
    //@ts-ignore
    if (this.$can(this.actions.manage, this.subjects.grantAgree) && !this.grant.selectedGrant.IsAgreementSigned) {
      // secratariat users with just review only roles doesnt need to enter grant agreement section in "Awarded status"
      return true;
    }
  }

  createGrantAmendment(amendmentType) {
    this.amendmentRequestLoader = true;
    this.suspensionLoader = true;
    this.terminationLoader = true;
    this.resumeLoader = true;
    
    let amendmentData = {
      AmendmentTypes: this.amendmentRequest.amendmentTypeId,
      GrantId: this.grant.selectedGrant.GrantId,
      Reason: this.amendmentRequest.reason
    }

    // Set amendment type for suspension/termination
    switch (amendmentType) {
      case 'suspend':
        amendmentData.AmendmentTypes[0] = 4903;
        break;
    
      case 'terminate':
        amendmentData.AmendmentTypes[0] = 4904;
        break;
    
      case 'resume':
        amendmentData.AmendmentTypes[0] = 4905;
        break;
    }

    this.$services.grantAmendment.createGrantAmendment(amendmentData)
      .then((data: any) => {
        this.amendmentRequestLoader = false;
        this.suspensionLoader = false;
        this.terminationLoader = false;
        this.resumeLoader = false;
        this.showAmendment = false;
        this.showSuspend = false;
        this.showTerminate = false;
        this.showResumeGrant = false;

        if (data.Result == 'ERROR') {
          this.notify({
            text: data.Message,
            isHtml: true,
            color: "error",
          });
        } else {
          this.amendmentRequest = {
            applicantId: 0,
            amendmentTypeId: [],
            reason: ""
          };
          
          // Redirects to the amendment type screen
          this.$router.push({
              name: "amendment",
              params: { amendmentId: data.Record.GrantAmendmentId },
              hash: '#summary'
          });
        }
      });
  }
}
